import { renderInDocument } from '@spotahome/soyuz/client';

import AllSearchListContainer from './main';

renderInDocument(AllSearchListContainer);
